import { Stack } from "@mui/material";
import { Typography } from "common/components/Typography";
import React from "react";

interface PropertyRowProps {
  label: string;
  value: React.ReactNode;
  secondValue?: React.ReactNode;
}

export const PropertyRow: React.FC<PropertyRowProps> = ({
  label,
  value,
  secondValue,
}) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <div
        style={{
          minWidth: "180px",
          alignSelf: "flex-start",
        }}
      >
        <Typography variant="caption" textStyle={{ fontSize: 16 }}>
          {label}
        </Typography>
      </div>
      <Stack direction="column">
        <Typography variant="body" numberOfLines={1}>
          {value}
        </Typography>
        {!!secondValue && (
          <Typography variant="body" numberOfLines={1}>
            {secondValue}
          </Typography>
        )}
      </Stack>
    </div>
  );
};
